<template>
  <el-dialog
    class="flow-dialog"
    :title="$t('i18n.ee6a2a33bf634ddba4ccdbaeca353f28')"
    :close-on-click-modal="false"
    append-to-body
    :visible.sync="visible"
  >
    <div class="create-flow-box">
      <div
        v-for="item in defaultFlowsLogo"
        :key="item.audit_type"
        class="create-flow-item"
        @click="handlerCreate(item)"
      >
        <!-- 创建自定义审批流 印尼时不能创建 -->
        <el-button type="text" class="item-content" :disabled="lang === 'id'" v-if="item.type === 2">
          <i class="el-icon-plus" />{{ $t('4280164e') }}
        </el-button>
        <!-- 创建固定审批流 -->
        <div v-else class="item-content item-btn-box" :class="{ 'border-solid': item.type !== 2 }">
          <div class="icon-box" :style="{ background: item.logo.color }">
            <i class="iconfont-2" :class="item.logo.name"></i>
          </div>
          <div class="explain-box">
            <h4 class="icon-title">{{ item.name }}</h4>
            <span class="visible-title">{{ item.explain }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { defaultFlowsLogo } from '../setting/form/enum'
import { getFlowTypes } from 'api/flow'
const dataInit = () => ({
  cn: '',
  th: '',
  en: ''
})
export default {
  props: {
    lang: {
      type: String
    }
  },
  data() {
    return {
      visible: false,
      form: dataInit(),
      defaultFlowsLogo: []
    }
  },
  methods: {
    init() {
      this.visible = true
      this.form = dataInit()
      // 获取审批流类型
      getFlowTypes().then(res => {
        this.defaultFlowsLogo = [defaultFlowsLogo, ...res.data]
      })
    },
    handlerCreate(item) {
      if (this.lang === 'id' && item.type === 2) return
      this.$router.push({
        path: '/approval/addSetting',
        query: { type: 'add', params: JSON.stringify(item) }
      })
    }
  }
}
</script>
